import RestResource from '../rest.service';

export default class CampaignsService extends RestResource {
  map(payload) {
    return {
      name: payload.name,
      from: payload.startDate,
      to: payload.endDate,
      active: payload.active,
      crops: payload.crops,
    };
  }

  constructor() {
    super('campaigns');
  }
}
